import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, withModifiers as _withModifiers, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fw-bold ext-display-name" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "d-none d-sm-inline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_Highlighter = _resolveComponent("Highlighter")!
  const _component_Clickable = _resolveComponent("Clickable")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_FormInputClearable = _resolveComponent("FormInputClearable")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component", _ctx.componentName]),
    part: _ctx.componentName
  }, [
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Dropdown, {
            open: _ctx.isAutocompleteVisible,
            "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAutocompleteVisible) = $event)),
            "min-width": "340px",
            items: _ctx.autocomplete.items
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_Clickable, {
                class: "dropdown-item",
                onClick: ($event: any) => (_ctx.searchText(item.text))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_Highlighter, {
                      highlightClassName: "text-primary p-0 display-inline bg-transparent ext-highlight",
                      highlightTag: "span",
                      searchWords: _ctx.autocompleteHighlightTerms,
                      autoEscape: true,
                      textToHighlight: item.text
                    }, null, 8, ["searchWords", "textToHighlight"])
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            footer: _withCtx(() => [
              (_ctx.isAutocompleteLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_Spinner, { sm: "" })
                  ]))
                : (_ctx.autocomplete.totalCount)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.t('ShowingNOfNMatches', false, [
                `${_ctx.autocomplete.visibleMatchCount || 0}`,
                `${_ctx.autocomplete.totalCount || 0}`,
              ])), 1))
                  : (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.t('NoResults')), 1))
            ]),
            activator: _withCtx(({ on }) => [
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onSearch()), ["prevent"])),
                class: "input-group flex-nowrap"
              }, [
                _createVNode(_component_FormInputClearable, _mergeProps({
                  modelValue: _ctx.searchModel.text,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchModel.text) = $event))
                }, _toHandlers(on), {
                  "class-inner": 'border-end-0',
                  placeholder: _ctx.t('SearchClassificationsInputPlaceholder'),
                  "onUpdate:modelValue": _ctx.onSearchInput,
                  onClear: _ctx.onClear,
                  onFocus: _ctx.openAutocomplete
                }), null, 16, ["modelValue", "placeholder", "onUpdate:modelValue", "onClear", "onFocus"]),
                _createVNode(_component_Btn, {
                  "aria-label": _ctx.t('SearchButtonText'),
                  icon: "search"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('SearchButtonText')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"])
              ], 32)
            ]),
            _: 1
          }, 8, ["open", "items"])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1)), [
    [_vShow, _ctx.visible]
  ])
}